import { useContext } from 'react';

import { AuthContext } from '@/lib/auth/AuthContext';
import type { AuthContextValue } from '@/lib/auth/AuthContext';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
